import { useDashboardFilters } from "@/features/dashboard/DashboardStateContext";
import { PagePost } from "@gettactic/api";
import { MarkdownView } from "@gettactic/components/src/controls/MarkdownEditor/MarkdownView";
import { PageTitleAndDesc } from "./PageTitleAndDesc";

export const PageView = ({
  page,
  relatedPages
}: {
  page: PagePost;
  relatedPages?: PagePost[];
}) => {
  const { setSelectedPageId } = useDashboardFilters();

  const isPageClickable = (page: PagePost) => {
    return page.content && page.content.length > 0;
  };

  const handleRelatedPageClick = (relatedPage: PagePost) => {
    if (isPageClickable(relatedPage)) {
      setSelectedPageId(relatedPage.id);
    }
  };

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-6">
        <div className="markdown-body !p-0 flex-1 rounded-lg bg-white">
          <PageTitleAndDesc title={page.title} description={""} />
          <MarkdownView markdown={JSON.parse(page?.content)?.content || ""} />
        </div>
        <div className="w-full rounded-lg bg-white py-6">
          {/* {relatedPages && relatedPages.length > 0 && (
            <div className="w-full rounded-lg bg-white py-6">
              <h2 className="mb-4 font-bold text-lg">Related Pages</h2>
              <PageGrid
                pages={relatedPages}
                onPageClick={handleRelatedPageClick}
              />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};
